import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core'
import { MediaQueryService } from '../../services/media-query-service'
import { Subscription } from 'rxjs'

@Component({
  selector: 'rating-stars',
  styles: [`
    :host {
      display: inline-block;
    }
  `],
  template: `
    <div class="rating">
      <ng-template [ngIf]="!isMobile || suppressMobile">
        <i *ngFor="let n of stars" class="fa-star text-primary"
              [ngClass]="{'fas': highlighted(n), 'far': !highlighted(n)}"
              [class.text-purple]="disabled"
              (click)="click(n, $event)"
              (mouseenter)="setHoverNumber(n)"
              (mouseleave)="clearHoverNumber()"></i>
      </ng-template>

      <div class="btn-group mobile-star-menu no-medium-or-larger" dropdown *ngIf="isMobile && !suppressMobile" container="body" placement="bottom right">
        <a class="btn btn-sm btn-outline-tertiary dropdown-toggle" dropdownToggle>
          <i class="fas fa-star text-primary" [class.full]="value" [class.text-muted]="disabled"></i>
          {{value}}
        </a>
        <div class="dropdown-menu dropdown-menu-right" *dropdownMenu>
          <div class="dropdown-item text-center">
            <i *ngFor="let n of stars" class="fa-star text-primary"
                  [ngClass]="{'fas': highlighted(n), 'far': !highlighted(n)}"
                  (click)="click(n); $event.stopPropagation()"
                  (mouseenter)="setHoverNumber(n)"
                  (mouseleave)="clearHoverNumber()">
            </i>
          </div>
        </div>
      </div>
    </div>
  `,
})
export class RatingStars {
  @Output() onChange: EventEmitter<number> = new EventEmitter<number>();
  @Input() value: number;
  @Input() disabled: boolean = false
  @Input() suppressMobile: boolean = false
  isMobile: boolean
  stars: number[] = stars;
  private hoverNumber: number = null;
  subs: Subscription[] = []

  constructor(
    public mediaQuery: MediaQueryService,
    private changeDetectorRef: ChangeDetectorRef
  ) {}

  ngOnInit() {
    const sub = this.mediaQuery.observeBreakpoint('isUnder', 'md').subscribe(isMobile => {
      this.isMobile = isMobile
      this.changeDetectorRef.detectChanges()
    })
    this.subs.push(sub)
  }

  ngOnDestroy() {
    this.subs.forEach(s => s.unsubscribe())
  }

  highlighted(n: number): boolean {
    const v = this.hoverNumber || this.value
    return v >= n
  }

  setHoverNumber(n: number): void {
    if (!this.disabled) {
      this.hoverNumber = n
    }
  }

  clearHoverNumber(): void {
    this.hoverNumber = null
  }

  click(n: number, event?: MouseEvent): void {
    if (!this.disabled) {
      this.onChange.emit(n)
    }
  }

  trackBy(i: number, n: number): number {
    return n
  }
}

const stars: number[] = [1, 2, 3, 4, 5]
